<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <title-comp/>
      </v-col>
    </v-row>
    <v-row class="ml-n8 mr-n8">
      <v-col cols="12">
        <v-data-table style="font-size: 90%;"
          v-if="!(matchingOpps!=null && matchingOpps.length==0 && totalFound>0)"
          :headers="headers"
          @click:row="onRowClicked"
          :items="preparedOpps"
          :custom-key-sort="customKeySort">
          <!-- Custom slot for the profiles field -->
          <template v-slot:[`item.profiles`]="{ item }">
            <div v-if="Array.isArray(item.profiles)">
                <span v-for="(profile, index) in item.profiles" :key="index">
                  {{ profile }}
                </span>
            </div>
          </template>
          <template v-slot:[`item.issuer`]="{ item }">
              {{ item.issuer?.firstName??"" }}&nbsp;{{ item.issuer?.lastName??"" }}
          </template>
          <template v-slot:[`item.resume`]="{ item }">
              {{ item.resume??'&#x1F615;' }}
          </template>
        </v-data-table>
        <h2 v-else><br>Too many results:<br>{{totalFound}} opps found (>100)</h2>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-dialog v-model="appevent.openSearchMenu" transition="dialog-top-transition" width="100%" height="100vh" persistent>
          <v-card width="Auto">
            <v-form validate-on="submit lazy" @submit.prevent="runSearch"
              style="border-top:1px solid gray;">
              <ContactAutocomplete
                      label="Issuer"
                      v-model="filter.SelectedIssuer"
                      :onSearch="onSearchIssuer"
                      prepend-inner-icon="mdi-account-voice"
                      />
              <ContactAutocomplete
                        label="Sales supervisors"
                        v-model="filter.SelectedSales"
                        :onSearch="onSearchSalesSuperv"
                        prepend-inner-icon="mdi-handball"
                        multiple/>
              <v-autocomplete
              prepend-inner-icon="mdi-list-status"
                      label="Opp states"
                      closable-chips
                      clearable
                      clear-on-select
                      v-model="filter.SelectedOppStates"
                      :custom-filter="utils.skillFilterFunction"
                      :items="refstore.OppStates"
                      auto-select-first="exact"
                      item-title="label"
                      item-value="id"
                      chips
                      ref="autocomplete1"
                      @update:modelValue="closeDropdown"
                      multiple/>
              <v-container class="ma-0 pa-0" fluid>
                <SkillsSelector :filter="filter"></SkillsSelector>
              </v-container>
              <ProfileSelector :filter="filter"></ProfileSelector>
            </v-form>
            <template v-slot:actions>
              <v-btn class="ms-auto" text="&#x1F9F9; Vider" @click="cleanFilter"></v-btn>
              <v-btn class="ms-auto" text="&#128269; Chercher" @click="runSearch"></v-btn>
              <v-btn class="ms-auto" text="&#10060; Fermer" @click="closeSearch"></v-btn>
            </template>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-dialog v-model="openRowDetail" transition="dialog-top-transition" width="100%" height="100vh" persistent>
          <v-card width="Auto">
            <v-container>

              <v-row no-gutters>
              <v-col cols="12">
                <div class="section_title">&#x2022; ISSUED</div>
                <div class="section_content" v-if="selectedItem.issueDate==null">
                  N/A
                </div>
                <div class="section_content" v-else>
                  {{ selectedItem.issueDate }}
                </div>
                <hr>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <div class="section_title">&#x2022; LAST ACTIVITY</div>
                <div class="section_content" v-if="selectedItemLastActivity==null">
                  N/A
                </div>
                <div  class="section_content">
                  <activity-infos :forOpp="true" :activity="selectedItemLastActivity"></activity-infos>
                </div>
                <hr>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <div class="section_title">&#x2022; STATUS</div>
                <div class="section_content" v-if="selectedItem.oppState!=null">
                  <div>State: {{ selectedItem.oppState.label }}</div>
                </div>
                <hr>
              </v-col>
            </v-row>
            <!-- Skills-->
            <v-row no-gutters>
              <v-col cols="12">
                <div style="padding-top: 1vh;"></div>
                <div class="section_title">&#x2022; SKILLS</div>
                <div class="section_content" v-if="selectedItem.oppSkills==null">
                  N/A
                </div>
                <div class="section_content" v-if="selectedItem.oppSkills">
                <span v-for="s in selectedItem.oppSkills" :key="s">{{ s.name }}, </span>
                </div>
                <hr>
              </v-col>
            </v-row>
            <!-- Profiles-->
            <v-row no-gutters>
              <v-col cols="12">
                <div style="padding-top: 1vh;"></div>
                <div class="section_title">&#x2022; PROFILES</div>
                <div class="section_content" v-if="selectedItem.profiles==null">
                  N/A
                </div>
                <div class="section_content" v-if="selectedItem.profiles">
                <span v-for="p in selectedItem.profiles" :key="p">{{ p }}, </span>
                </div>
                <hr>
              </v-col>
            </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <div style="padding-top: 1vh;"></div>
                  <div class="section_title">&#x2022; DOCUMENTS</div>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5"/>
                <v-col cols="2">
                  <Spinner style="text-align: center;" v-if="docList == null"/>
                </v-col>
                <v-col cols="5"/>
              </v-row>
              <template v-if="docList != null && docList.length>0">
                <v-row @click="downloadDocument(d.docId)" no-gutters v-for="d in docList" :key="d.docId" class="liste-doc-class section_content">
                  <v-col cols="12" style="padding-top: 1%; padding-bottom: 1%;">
                    <p>&#x1F441;</p> [{{d.date}}] {{d.name}}
                  </v-col>
                </v-row>
              </template>
              <template v-if="docList != null && docList.length==0">
                  <div style="font-family: aldrich; border-top: 1px solid black; padding-top: 2%;">Aucun document trouvé &#x1f63f;</div>
              </template>
            </v-container>
            <hr>
            <template v-slot:actions>
              <v-btn
                v-html="toutVoirtext"
                @click="viewAllDocs=!viewAllDocs"
                color="black lighten-1">
              </v-btn>
              <v-btn class="ms-auto" text="&#10060; Fermer" @click="openRowDetail=false"></v-btn>
            </template>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleComp from '@/components/TitleComp.vue' // Assurez-vous que le chemin est correct
import { AppEventsStore, ReferentialStore } from '@/stores'
import { LynxUtils } from '@/utils'
import { ContactSvcInstance, OppSvcInstance, DocSvcInstance } from '@/lynxapi'
import ContactFilteringCategoryEnum from '@/utils/ContactFilteringCategoryEnum.js'
import ContactAutocomplete from '@/components/ContactAutocomplete.vue'
import SkillsSelector from '@/components/SkillsSelector.vue'
import ProfileSelector from '@/components/ProfileSelector.vue'
import { DatabaseServiceInstance } from '@/database'
import Spinner from '@/components/Spinner.vue'
import ActivityInfos from '@/components/ActivityInfos.vue'
import '@/assets/viewdetailstyles.css'

export default {
  components: {
    TitleComp,
    ContactAutocomplete: ContactAutocomplete,
    SkillsSelector,
    ProfileSelector,
    Spinner,
    ActivityInfos
  },
  computed: {
    appevent: function () {
      return AppEventsStore()
    },
    refstore: function () {
      return ReferentialStore()
    },
    utils: function () {
      return LynxUtils
    },
    preparedOpps: function () {
      return this.matchingOpps.map(opp => ({
        ...opp,
        fullName: `${opp.firstName} ${opp.lastName}`
      }))
    }
  },
  data: () => ({
    filter: {
      SelectedIssuer: null,
      SelectedSales: [],
      SelectedOppStates: [],
      SelectedSkills: [],
      SelectedPositionTypes: [],
      Allskills: false
    },
    matchingOpps: [],
    totalFound: 0,
    openRowDetail: false,
    selectedItem: null,
    selectedItemLastActivity: null,
    docList: null,
    headers: [
      {
        title: 'Client',
        align: 'start',
        sortable: true,
        key: 'accountName'
      },
      { title: 'Resumé', key: 'resume' },
      { title: 'Issued', key: 'issueDate' },
      { title: 'Profile', key: 'profiles' },
      { title: 'Issuer', key: 'issuer' }
    ],
    customKeySort: {
      issueDate: (a, b) => {
        const parse = (value) => {
          if (!value) return 0
          // value attendu : "jj/MM/AAAA"
          const [day, month, year] = value.split('/')
          return new Date(
            Number(year),
            Number(month) - 1,
            Number(day)
          ).getTime()
        }

        return parse(a) - parse(b)
      }
    }
  }),
  methods: {
    async onRowClicked (event, item) {
      this.openRowDetail = true
      this.selectedItem = item.item
      this.docList = null
      this.docList = await DocSvcInstance.findDocumentsForOpp(this.selectedItem.id)
      this.selectedItemLastActivity = await OppSvcInstance.findLastActivityForOpp(this.selectedItem.id)
    },
    async downloadDocument (docId) {
      await DocSvcInstance.downloadDocument(docId)
    },
    formatProfile (profile) {
      // Formatage personnalisé pour chaque chaîne de caractères dans profiles
      return `Profil: ${profile}`
    },
    buildFnLn: function (contact) {
      return contact.firstName + ' ' + contact.lastName
    },
    closeDropdown () {
      // Accède à la référence de v-autocomplete et déclenche la méthode blur pour fermer le menu
      this.$refs.autocomplete1.blur()
    },
    runSearch: async function () {
      DatabaseServiceInstance.saveFilter('opp', this.filter)
      const res = await OppSvcInstance.findMatchingOpps(this.filter)
      this.matchingOpps = res?.result
      this.totalFound = res?.count
      this.closeSearch()
    },
    closeSearch: function () {
      this.appevent.openSearchMenu = false
    },
    cleanFilter: function () {
      this.filter = {}
    },
    onSearchIssuer: async function (searchInput) {
      return await ContactSvcInstance.autocompleteContact(searchInput, ContactFilteringCategoryEnum.ALL, true)
    },
    onSearchSalesSuperv: async function (searchInput) {
      return await ContactSvcInstance.autocompleteContact(searchInput, ContactFilteringCategoryEnum.SALES, true)
    }
  },
  async mounted () {
    this.filter = await DatabaseServiceInstance.loadFilter('opp')
  }
}
</script>
